<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="customStyle"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.5542 6.138L7.89927 10.7929L3.24432 6.138"
      stroke="#68737D"
      stroke-width="1.48958"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'DropdownIcon',
  props: {
    customStyle: {
      type: String,
      default: 'h-6 w-6',
    },
  },
}
</script>
